(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/views/tipsen/matchlist.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/views/tipsen/matchlist.js');

'use strict';

svs.game_results.views.MatchList = Marionette.CollectionView.extend({
  childView: svs.game_results.views.Match
});

 })(window);